// Single source of truth for the tenant identifier sent on routes that bypass
// api-gw's X-tenant injection (multipart uploads + websockets).
//
// pda-be routes its datasources by tenant NAME — the exact value api-gw forwards
// from AAS on every normal call. The bypass routes used to send `tenant.id`
// instead, which silently resolved to the wrong (default) datasource and, since
// the multi-tenant "fail-closed" change, is rejected with HTTP 400
// "unconfigured tenant". Reading the name here keeps every bypass site on one
// identical method, consistent with the classic (api-gw) path.
//
// The authoritative source is the Redux store (currentUser.user.tenant), hydrated
// from GET /users/self — that's where the active tenant (with its name) actually
// lives. localStorage "user" is a legacy fallback and is usually empty, so pass
// the Redux state in: thunks via getState(), other callers via store.getState().
export function getActiveTenantName(state) {
  const fromState = state?.currentUser?.user?.tenant?.name;
  if (fromState) return fromState;
  try {
    return JSON.parse(localStorage.getItem("user") || "{}")?.tenant?.name ?? null;
  } catch {
    return null;
  }
}

// Convenience for axios `headers`: returns {} when no tenant is resolvable so
// callers can spread it without sending an empty header.
export function getActiveTenantHeader(state) {
  const name = getActiveTenantName(state);
  return name ? { "X-tenant": name } : {};
}
